import http from '../httpService';

const CommunityService = {
  getCommunityService: params => http.get('community-service', { params }),
};

export default CommunityService;
